<template>
  <div class="page">
    <my-header centerType="button">
      <template v-slot:let>
        <img style="width: 7vh;" src="@/assets/images/back.png" alt="" @click="onClickBack">
      </template>
      <template v-slot:middle>
        <div class="mytitle">{{ $store.state.editor.product.title }}</div>
      </template>
      <template v-slot:right>
      </template>
    </my-header>
    <div id="affixContainer" style="overflow-y: auto;" :style="{ height: contentHeight + 'px' }">
      <div class="design-content-phone" style="display: flex;flex-direction: column;">
        <vue-affix-box ref="affix" target="#affixContainer" :offset-top="0">
          <div style="width: calc(100vw - 20px);background-color: white;display: flex;justify-content: center;">
            <div ref="canvasWrapper" style="margin-left: auto;margin-right: auto;">
              <div ref="canvasContainer" style="height: 50vh;">
                <canvas ref="canvas"></canvas>
              </div>
            </div>
          </div>
        </vue-affix-box>
        <inprint-list ref="inprintlist"  @change="changeInprint"></inprint-list>
        <el-card class="box-card-phone">
          <el-form ref="form" label-width="50px">
            <props-table :props="$store.state.editor.components" @change="change"></props-table>
          </el-form>
        </el-card>
      </div>
    </div>
    <div style="display: flex;justify-content: center;align-items: center;">
      <el-button round style="width: 120px;margin: 10px;" size="small" type="primary" @click="onClickBuy">购买</el-button>
    </div>
    <image-editor ref="imageEditor" :class="{ 'far': !activeProcesser }" @close="onClose" @crop="onCrop" @revert="onRevert"></image-editor>
  </div>
</template>

<script>
import axios from 'axios'
import MyHeader from '@/components/Header'
import * as PIXI from 'pixi.js'
import { clone } from 'lodash-es'
import { loadTexture, blobToBase64, getVertices, upload2qn, base64ToBlob, getUploadToken, getItem, setItem, rgbToHex } from '../../utils/Utils.js'
import { Sprite, getBlendFilter } from '@pixi/picture'
import { OutlineFilter } from 'pixi-filters'
import options from '../../utils/config'
import { Sprite2d } from 'pixi-projection'
import { ColorOverlayFilter } from '@pixi/filter-color-overlay'
import ConvertFile from '../../utils/ConvertFile.js'
import moment from 'dayjs'
import PropsTable from '@/components/PropsTable.vue'
import ImageEditor from '@/components/ImageEditor.vue'
import localforage from 'localforage'
import { createOrder, getAccessToken } from '@/api/order'
import InprintList from '@/components/InprintList.vue'
import { Message } from 'element-ui'
import VueAffixBox from 'vue-affix-box'

const SUPPORTED_BLEND_MODES = [
  'NORMAL',
  'ADD',
  'SUBTRACT',
  'MULTIPLY',
  'XOR',
  'SRC_IN',
  'SRC_OUT',
  'SRC_ATOP',
  'DST_OVER',
  'DST_IN',
  'DST_OUT',
  'DST_ATOP',
  'SCREEN',
  'OVERLAY',
  'SOFT_LIGHT',
  'HARD_LIGHT'
]

export default {
  components: {
    MyHeader,
    PropsTable,
    ImageEditor,
    InprintList,
    VueAffixBox
  },
  data () {
    return {
      contentHeight: window.innerHeight * 0.93 - 52,
      imageList: [],
      currentColor: null,
      tempSrc: '',
      activeProcesser: false,
      disabledPrint: false,
      crops: null,
      pixiContainer: null,
      pixiApp: null,
      keyList: []
    }
  },
  computed: {
    baseURL () {
      return this.$store.state.editor.baseURL
    }
  },
  async activated () {
    // const { data } = await axios.get('https://uc.shareuc.com/render/PhoneCase.psd_20211228144324.json')
    // data.name = '手机壳'
    // await this.$store.dispatch('setEditor', data)
    // this.$store.state.editor.inprint = {
    //   type: 'panel',
    //   sizeX: 516,
    //   sizeY: 1000
    // }
    // this.$store.state.editor.inprints = [{
    //   type: 'panel'
    // }]
    // this.$store.state.editor.product = {
    //   name: data.name,
    //   id: 1
    // }
    await this.loadScene()
  },
  methods: {
    getSize () {
      let size = ''
      this.$store.state.editor.components.forEach((component) => {
        if (component.name === 'radio-item') {
          size = component.props.size
        }
      })
      return size
    },
    async onClickBuy () {
      this.$store.state.ui.loading = true
      // 获取设计数据
      const inprints = await this.getProductCrops()
      const size = this.getSize()
      const json = {
        name: this.$store.state.editor.product.name, // 产品名称
        id: this.$store.state.editor.product.id, // 产品id
        color: this.getRadioColor(),
        inprints,
        design: {
          inprint: {
            umb: [{
              index: 0,
              X: 0,
              Y: 0,
              ZV: 1,
              SV: 1,
              AV: 0,
              url: '',
              source: '',
              textlist: [],
              imagelist: [],
              color: '',
              pantone: '',
              texture: '',
              caption: ''
            }]
          }
        }
      }
      if (size !== '') {
        json.size = size
      }
      const tasks = []
      const uploadName = this.genName()
      // 上传场景效果图
      const currentInprint = JSON.parse(JSON.stringify(this.$store.state.editor.inprint))
      const currentCapture = await this.getSceneCapture(currentInprint.type)
      tasks.push({
        key: currentInprint.index === 0 ? uploadName : `${uploadName}_${currentInprint.type}`,
        base64: currentCapture
      })
      for (const inprint of this.$store.state.editor.inprints) {
        if (currentInprint.type === inprint.type) continue
        await this.changeInprint(inprint, false)
        const sceneCapture = this.getSceneCapture(inprint.type)
        tasks.push({
          key: inprint.index === 0 ? uploadName : `${uploadName}_${inprint.type}`,
          base64: sceneCapture
        })
      }
      await this.changeInprint(currentInprint, false)
      // 上传json
      await this.uploadJson(uploadName, json)
      // 上传用到的本地图片
      await this.uploadImages(inprints)
      const loopTasks = async () => {
        for (let i = 0; i < tasks.length; i++) {
          const task = tasks[i]
          const key = `${name}${task.key}.png`
          const blob = base64ToBlob(task.base64, 'image/png')
          const token = await getUploadToken()
          const fd = new FormData()
          fd.append('key', key)
          fd.append('token', token)
          fd.append('file', blob)
          await upload2qn(fd)
        }
      }
      await loopTasks()
      // 生成单号
      const orderJson = {
        name: uploadName,
        umb: this.$store.state.editor.product.id,
        quantity: 1,
        done: 1,
        time: moment().format('YYYY-MM-DD HH:mm:ss'),
        brand: this.$store.state.brand.brand,
        user: 'web',
        note: ''
      }
      const token = await getAccessToken()
      const formData = new FormData()
      formData.append('data', JSON.stringify(orderJson))
      formData.append('access_token', token)
      const { data: order } = await createOrder(formData)
      const created = order.data.order_id + '_' + order.data.order_code
      console.log('生成订单', created)
      const cartData = {
        name: uploadName,
        created,
        status: 0
      }
      // 保存到购物车
      this.$store.commit('addShopCart', {
        type: 'render',
        order: cartData
      })
      this.$store.commit('saveShopCart')
      // 跳转详情页
      this.$store.commit('push', '/detail?id=' + created)
      this.$store.state.ui.loading = false
      setTimeout(() => {
        // 清除数据
        this.clear()
        this.$store.dispatch('setEditor', {
          name: '',
          layers: []
        })
        for (const key of this.keyList) {
          localforage.removeItem(key)
        }
        this.keyList = []
      }, 1000)
    },
    genName () {
      if (this.$store.state.designer) {
        return moment().format('YYYYMMDDHHmmss') + `_${this.$store.state.config.brand}_(render_)-png-` + this.$store.state.designer.mer_id
      } else {
        return moment().format('YYYYMMDDHHmmss') + `_${this.$store.state.config.brand}_(render_)-png`
      }
    },
    async onClickBack () {
      this.clear()
      await this.$store.dispatch('setEditor', {
        name: '',
        layers: []
      })
      this.$router.push('/product')
      for (const key of this.keyList) {
        await localforage.removeItem(key)
      }
      this.keyList = []
    },
    changePrintType (e) {
      const arr = e.split('_')
      this.imageList[parseInt(arr[0])].printType = arr[1]
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (
          restaurant.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        )
      }
    },
    async getInprint (inprint) {
      // 从本地加载
      const localData = await getItem(`${this.$store.state.editor.product.name}_${inprint.type}`)
      if (localData) {
        return JSON.parse(localData)
      } else if (inprint.name.endsWith('.json')) {
        const url = `${this.baseURL}/${inprint.name}`
        const { data } = await axios.get(url)
        return data
      }
    },
    async changeInprint (inprint) {
      if (this.$store.state.editor.changingInprint) return
      this.$store.state.editor.changingInprint = true
      // 保存当前设计
      if (this.$store.state.editor.inprints) {
        const key = `${this.$store.state.editor.product.name}_${this.$store.state.editor.inprint.type}`
        this.keyList.push(key)
        await this.$store.dispatch('saveInprint', key)
      }
      // 切换设计
      this.$store.state.editor.inprint = inprint
      const name = inprint.name
      // 从本地加载
      const localData = await getItem(`${this.$store.state.editor.product.name}_${this.$store.state.editor.inprint.type}`)
      if (localData) {
        const jsondData = JSON.parse(localData)
        await this.$store.dispatch('setEditor', jsondData)
        await this.loadScene()
      } else if (name.endsWith('.json')) {
        let data = null
        if (!this.$store.state.editor.localJson) {
          const url = `${this.baseURL}/${name}`
          const res = await axios.get(url)
          data = res.data
        } else {
          const url = `/json/${name}`
          const res = await axios.get(url)
          data = res.data
        }
        await this.$store.dispatch('setEditor', data)
        await this.loadScene()
      } else {
        Message({
          message: '不支持该格式',
          type: 'error'
        })
      }
      this.$store.state.editor.changingInprint = false
    },
    pointerout (target) {
      if (target._highlight) {
        target._highlight = false
        target.filters.splice(-2, 2)
      }
    },
    async pointerover (target) {
      // console.log('选中', target.name)
      if (!target._highlight) {
        target._highlight = true
        target.filters.push(new ColorOverlayFilter(0x99ff99, 0.5))
        target.filters.push(new OutlineFilter(6, 0x99ff99))
      }
    },
    onClose () {
      this.tempSrc = ''
      this.activeProcesser = false
    },
    onRevert () {
      this.showProcesser(this.tempSrc)
    },
    onCrop (data) {
      // console.log('onCrop', this.$store.state.editor.currentLayer?.props.id, data)
      this.change({
        id: this.$store.state.editor.currentLayer?.props.id,
        valueProp: 'src',
        value: data.src,
        crop: data.crop
      })
    },
    async getSceneCrops (list, data, inprint) {
      for (let i = 0; i < data.layers.length; i++) {
        const layer = data.layers[i]
        if (layer.layers) {
          await this.getSceneCrops(list, layer, inprint)
        } else {
          if (layer.type === 'smart-object' || layer.type === 'clip') {
            // 取本地裁切数据
            const cropData = await this.getCrop(layer, this.$store.state.editor.product.name, inprint)
            if (cropData) {
              cropData.visible = layer.props?.visible
              list.push(cropData)
            }
          }
        }
      }
    },
    async getProductCrops () {
      const productCrops = []
      for (let i = 0; i < this.$store.state.editor.inprints.length; i++) {
        const inprint = this.$store.state.editor.inprints[i]
        const crop = {
          inprint: inprint.type,
          layers: []
        }
        // 读取本地场景数据（有修改过必然有本地数据，否则不处理）
        let sceneData = await getItem(`${this.$store.state.editor.product.name}_${inprint.type}`)
        if (sceneData) {
          sceneData = JSON.parse(sceneData)
          await this.getSceneCrops(crop.layers, sceneData, inprint.type)
        }
        productCrops.push(crop)
      }
      return productCrops
    },
    async getCrop (layer, product, inprint) {
      // console.log('getCrop', inprint, layer)
      if (!layer) {
        return null
      }
      let localData = null
      const name = layer.props ? layer.props.label : layer.name
      if (!layer.props) {
        layer.globalKeys = []
        layer.globalProps = []
        if (layer.global) {
          const globals = layer.global.split(',')
          globals.forEach((global) => {
            const arr = global.split('.')
            layer.globalKeys.push(arr[0])
            layer.globalProps.push(arr[1])
          })
        }
      }
      const globalProps = layer.props ? layer.props.globalProps : layer.globalProps
      const globalKeys = layer.props ? layer.props.globalKeys : layer.globalKeys
      const indexCrop = globalProps.indexOf('crop')
      if (indexCrop > -1) {
        const cropKey = globalKeys[indexCrop]
        const newKey = `${product}_${cropKey}_crops`
        localData = await getItem(newKey)
        this.keyList.push(newKey)
        // console.log('获取裁切数据1', newKey, JSON.parse(localData))
      } else {
        const newKey = `${product}_${inprint}_${name}_crops`
        localData = await getItem(newKey)
        this.keyList.push(newKey)
        // console.log('获取裁切数据2', newKey, JSON.parse(localData))
      }
      if (localData) {
        return JSON.parse(localData)
      } else {
        return {
          name,
          items: []
        }
      }
    },
    async showProcesser (src = '') {
      this.tempSrc = src
      if (!this.$store.state.editor.currentLayer) {
        console.log('未选中层')
        return
      }
      const cropData = await this.getCrop(this.$store.state.editor.currentLayer, this.$store.state.editor.product.name, this.$store.state.editor.inprint.type)
      if (!cropData) return
      this.$store.commit('setCrop', cropData)
      this.activeProcesser = true
      if (this.$refs.imageEditor) {
        const editor = this.$refs.imageEditor
        editor.load({
          src: src || this.$store.state.editor.currentLayer.props.src,
          mask: this.$store.state.editor.currentLayer.props.mask,
          size: {
            width: this.$store.state.editor.currentLayer.props.size.width,
            height: this.$store.state.editor.currentLayer.props.size.height
          }
        })
      }
    },
    clear () {
      if (this.pixiContainer) {
        this.pixiContainer.removeChildren(0, this.pixiContainer.children.length).forEach(c => {
          c.destroy({
            children: true,
            texture: true,
            baseTexture: true
          })
        })
      }
    },
    async loadScene () {
      this.$store.state.ui.loading = true
      this.clear()
      if (!this.$refs.canvasContainer) {
        return
      }
      if (!this.$refs.canvasWrapper) {
        return
      }
      if (!this.$refs.canvas) {
        return
      }

      let w1 = window.innerWidth - 20
      let h1 = this.$store.state.editor.json.size.height / this.$store.state.editor.json.size.width * w1

      if (h1 > window.innerHeight * 0.5) {
        h1 = window.innerHeight * 0.5
        w1 = this.$store.state.editor.json.size.width / this.$store.state.editor.json.size.height * h1
      }

      this.$refs.canvasWrapper.style.width = w1 + 'px'
      this.$refs.canvasWrapper.style.height = h1 + 'px'

      const w2 = this.$store.state.editor.json.size.width
      const h2 = this.$store.state.editor.json.size.height

      const space = 0
      let parentRatio = 1
      if (!this.$store.state.ui.os.isPC) {
        parentRatio = (w1 - space) / w2
      } else {
        parentRatio = Math.min((w1 - space) / w2, (h1 - space) / h2)
      }
      this.$refs.canvasContainer.style.width = `${w2}px`
      this.$refs.canvasContainer.style.height = `${h2}px`
      this.$refs.canvas.style.width = `${w2}px`
      this.$refs.canvas.style.height = `${h2}px`
      this.$refs.canvasContainer.style.transform = `scale(${parentRatio})`
      this.$refs.canvasContainer.style.transformOrigin = 'left top'

      this.initScene()

      this.pixiContainer.alpha = 0

      const graphics = new PIXI.Graphics()
      graphics.beginFill(0xDE3249)
      graphics.drawRect(0, 0, this.$store.state.editor.json.size.width, this.$store.state.editor.json.size.height)
      graphics.endFill()
      this.pixiContainer.mask = graphics

      const bg = new PIXI.Sprite(PIXI.Texture.EMPTY)
      bg.name = 'emptyBg'
      bg.width = this.$store.state.editor.json.size.width
      bg.height = this.$store.state.editor.json.size.height
      this.pixiContainer.name = this.$store.state.editor.name
      this.pixiContainer.addChild(bg)

      await this.addLayers(this.$store.state.editor.json)

      this.addWatermark()
      this.pixiContainer.alpha = 1

      this.$store.state.ui.loading = false
    },
    async addLayers (layer) {
      const layers = clone(layer.layers).reverse()
      // console.log(layers)
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].layers) {
          await this.addLayers(layers[i])
        } else {
          await this.addLayer(layers, layers[i])
        }
      }
    },
    addWatermark () {
      const style = new PIXI.TextStyle({
        fontFamily: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'normal',
        fill: ['0x0000009']
      })
      var richText = new PIXI.Text('@YOUSEE定制', style)
      richText.name = 'watermark'
      richText.anchor.set(0.5)
      richText.position.set(this.$store.state.editor.json.size.width - 110, this.$store.state.editor.json.size.height - 30)
      richText.visible = false
      this.pixiContainer.addChild(richText)
      this.pixiContainer._watermark = richText
    },
    async addLayer (layers, layer) {
      if (layer.type === 'radio') return
      // console.log('addLayer', layer)
      let bunny = null
      if (layer.type === 'mask') return
      if (layer.type !== 'clip' && layer.type !== 'color' && layer.type !== 'normal' && layer.type !== 'smart-object') return
      if ((layer.type === 'normal' || layer.type === 'color')) {
        // console.log('普通层', layer.name, layer.props)
        const mask = await this.addMask(layers, layer)
        let texture = null
        // if (layer.type === 'clip' && maskLayer) {
        //   layer.src = maskLayer.src
        // }
        if (!layer.src) {
          texture = PIXI.Texture.WHITE
        } else {
          texture = await loadTexture(layer.src)
        }
        bunny = new Sprite(texture)
        if (layer.props) {
          bunny.visible = layer.props.visible
        }
        bunny.name = layer.name
        bunny.filters = []
        bunny._highlight = false
        bunny.width = layer.size.width
        bunny.height = layer.size.height
        bunny.x = layer.position.x
        bunny.y = layer.position.y
        bunny.alpha = layer.opacity / 100
        this.pixiContainer.addChild(bunny)
        this.$store.commit('updateComponent', {
          id: layer.id,
          valueProp: 'pixiObj',
          value: bunny
        })
        if (mask) {
          bunny.mask = mask
        }
        const filter = this.getFilter(PIXI.BLEND_MODES[layer.blend_mode])
        if (filter) {
          bunny.filters = [filter]
        } else if (SUPPORTED_BLEND_MODES.includes(layer.blend_mode)) {
          bunny.blendMode = PIXI.BLEND_MODES[layer.blend_mode]
        }
        if (layer.type === 'color' && layer.props && layer.props.color) {
          bunny.tint = layer.props.color.replace('#', '0x')
        }
        if (layer.name === 'Choose Any Color' && layer.props && layer.props.color) {
          bunny.tint = layer.props.color?.replace('#', '0x')
        }
      } else if (layer.smartobject && layer.smartobject.warp && layer.smartobject.warp.meshPoints) {
        // console.log('贝塞尔变换', layer.name, layer.blend_mode)
        // 遮罩
        const mask = await this.addMask(layers, layer)
        let texture = null
        if (layer.props && layer.props.crop) {
          texture = await loadTexture(layer.props.crop)
        } else if (!layer.smartobject.src) {
          let ratio = 1
          const max = Math.max(layer.smartobject.size.width, layer.smartobject.size.height)
          if (max > 2000) {
            ratio = max / 2000
          }
          const url = `https://uc.shareuc.com/${this.$store.state.editor.defaultImg}?imageMogr2/gravity/Center/crop/${layer.smartobject.size.width / ratio}x${layer.smartobject.size.height / ratio}`
          texture = await loadTexture(url)
          const { data } = await axios({
            method: 'get',
            responseType: 'blob',
            url
          })
          const base64 = await blobToBase64(data)
          this.$store.commit('updateEditor', {
            id: layer.id,
            valueProp: 'src',
            value: base64
          })
        } else {
          texture = await loadTexture(layer.smartobject.src)
        }
        bunny = new PIXI.SimplePlane(texture, options.gridSize, options.gridSize)
        if (layer.props) {
          bunny.visible = layer.props.visible
        }
        bunny.name = layer.name
        bunny.alpha = layer.opacity / 100
        bunny.filters = []
        bunny._highlight = false
        const points = getVertices(layer.smartobject.warp.meshPoints)
        var vertices = bunny.geometry.getBuffer('aVertexPosition').data
        for (var i = 0; i < vertices.length / 2; i++) {
          var j = i * 2
          vertices[j] = points[i].x
          vertices[j + 1] = points[i].y
        }
        bunny._points = points
        bunny.interactive = true
        bunny.buttonMode = true
        bunny.on('pointerover', () => {
          this.$store.commit('setCurrentLayerById', layer.id)
          this.pointerover(bunny)
        })
        bunny.on('pointerout', () => {
          this.pointerout(bunny)
        })
        bunny.on('pointerdown', () => {
          this.$store.commit('setCurrentLayerById', layer.id)
          this.showProcesser()
        })
        if (mask) {
          bunny.mask = mask
        }
        this.pixiContainer.addChild(bunny)
        this.$store.commit('updateComponent', {
          id: layer.id,
          valueProp: 'pixiObj',
          value: bunny
        })
        const filter = this.getFilter(PIXI.BLEND_MODES[layer.blend_mode])
        if (filter) {
          bunny.filters = [filter]
        }
      } else if (layer.filters && layer.filters.perspective) {
        // console.log('透视变换', layer.name, layer.blend_mode)
        // 遮罩
        const mask = await this.addMask(layers, layer)
        let texture = null
        if (layer.props && layer.props.crop) {
          texture = await loadTexture(layer.props.crop)
        } else if (!layer.smartobject.src) {
          let ratio = 1
          const max = Math.max(layer.smartobject.size.width, layer.smartobject.size.height)
          if (max > 2000) {
            ratio = max / 2000
          }
          const url = `https://uc.shareuc.com/${this.$store.state.editor.defaultImg}?imageMogr2/gravity/Center/crop/${layer.smartobject.size.width / ratio}x${layer.smartobject.size.height / ratio}`
          texture = await loadTexture(url)
          const { data } = await axios({
            method: 'get',
            responseType: 'blob',
            url
          })
          const base64 = await blobToBase64(data)
          this.$store.commit('updateEditor', {
            id: layer.id,
            valueProp: 'src',
            value: base64
          })
        } else {
          texture = await loadTexture(layer.smartobject.src)
        }
        bunny = new Sprite2d(texture)
        if (layer.props) {
          bunny.visible = layer.props.visible
        }
        bunny.name = layer.name
        bunny.filters = []
        bunny._highlight = false
        bunny.width = layer.smartobject.size.width
        bunny.height = layer.smartobject.size.height
        bunny.alpha = layer.opacity / 100
        this.pixiContainer.addChild(bunny)
        this.$store.commit('updateComponent', {
          id: layer.id,
          valueProp: 'pixiObj',
          value: bunny
        })
        bunny.proj.mapSprite(bunny, layer.filters.perspective.corners)
        bunny.interactive = true
        bunny.buttonMode = true
        bunny.on('pointerover', () => {
          this.$store.commit('setCurrentLayerById', layer.id)
          this.pointerover(bunny)
        })
        bunny.on('pointerout', () => {
          this.pointerout(bunny)
        })
        bunny.on('pointerdown', () => {
          this.$store.commit('setCurrentLayerById', layer.id)
          this.showProcesser()
        })
        if (mask) {
          bunny.mask = mask
        }
        const filter = this.getFilter(PIXI.BLEND_MODES[layer.blend_mode])
        if (filter) {
          bunny.filters = [filter]
        }
      }
      return bunny
    },
    getFilter (blendMode) {
      let filter = null
      if (blendMode === 2) {
        filter = new OutlineFilter(0, 0xffffff)
        filter.blendMode = PIXI.BLEND_MODES.MULTIPLY
      } else {
        filter = getBlendFilter(PIXI.BLEND_MODES[blendMode])
      }
      return filter
    },
    async addMask (layers, layer) {
      let maskLayer = null
      if (layer.has_clip) {
        layers.filter((l) => {
          if (l.id && l.id === layer.clip) {
            maskLayer = l
          }
        })
      } else if (layer.has_mask) {
        layers.filter((l) => {
          if (l.id && l.id === layer.mask) {
            maskLayer = l
          }
        })
      }
      // 同级找不到maskLayer到最外层找
      if (!maskLayer) {
        this.$store.state.editor.json.layers.filter((l) => {
          if (l.id && l.id === layer.mask) {
            maskLayer = l
          }
        })
      }
      // 遮罩
      let mask = null
      if (maskLayer) {
        if (layer.has_clip) {
          mask = await this.addLayer(layers, maskLayer)
        } else {
          const maskTexture = await loadTexture(maskLayer.src || maskLayer.src1)
          mask = new PIXI.Sprite(maskTexture)
          mask.width = maskLayer.size.width
          mask.height = maskLayer.size.height
          mask.x = maskLayer.position.x
          mask.y = maskLayer.position.y
          this.pixiContainer.addChild(mask)
        }
      }
      return mask
    },
    initScene () {
      if (!this.$refs.canvasContainer) {
        return
      }
      if (!this.$refs.canvas) {
        return
      }
      if (this.pixiApp) {
        this.pixiApp.renderer.resize(this.$store.state.editor.json.size.width, this.$store.state.editor.json.size.height)
      }
      if (this.pixiContainer) return
      const app = new PIXI.Application({
        view: this.$refs.canvas,
        width: this.$store.state.editor.json.size.width,
        height: this.$store.state.editor.json.size.height,
        backgroundColor: 0xffffff,
        resolution: !this.$store.state.ui.os.isPC ? 1 : window.devicePixelRatio,
        antialias: false
      })
      const container = new PIXI.Container()
      container.alpha = 0

      app.stage.addChild(container)

      container.x = 0
      container.y = 0

      this.pixiApp = app
      this.pixiContainer = container
    },
    async setImage (target, data) {
      if (!target || !target.props || !target.props.pixiObj) return
      const texture = await loadTexture(data.crop)
      target.props.pixiObj.texture = texture
      if (target.props.pixiObj._points) {
        const points = target.props.pixiObj._points
        const bunny = target.props.pixiObj
        var vertices = bunny.geometry.getBuffer('aVertexPosition').data
        for (var i = 0; i < vertices.length / 2; i++) {
          var j = i * 2
          vertices[j] = points[i].x
          vertices[j + 1] = points[i].y
        }
      }
    },
    setVisible (target, data) {
      if (!target || !target.props || !target.props.pixiObj) return
      if (target) {
        target.props.pixiObj[data.valueProp] = data.value
      }
    },
    setColor (target, data) {
      if (!target || !target.props || !target.props.pixiObj) return
      if (data.value.indexOf('rgb(') > -1) {
        const arr = data.value.replace('rgb(', '').replace(')', '').split(',')
        data.value = rgbToHex(Number.parseInt(arr[0]), Number.parseInt(arr[1]), Number.parseInt(arr[2]))
      }
      target.props.pixiObj.tint = data.value.replace('#', '0x')
    },
    getLayer (target, id) {
      for (let i = 0; i < target.layers.length; i++) {
        const l = target.layers[i]
        if (l.layers) {
          const ret = this.getLayer(l, id)
          if (ret) {
            return ret
          }
        } else if (l.id + '' === id + '') {
          return l
        }
      }
    },
    async change (e) {
      let reload = false
      const layer = this.getLayer(this.$store.state.editor.json, e.id)
      if (layer) {
        const globalIndex = layer.globalProps.indexOf(e.valueProp)
        if (globalIndex > -1) {
          const newKey = `${this.$store.state.editor.product.name}_${layer.globalKeys[globalIndex]}_${layer.globalProps[globalIndex]}`
          // console.log('保存全局配置', newKey, e.value)
          await setItem(newKey, e.value)
          this.keyList.push(newKey)
          if (e.valueProp === 'src') {
            const newKey = `${this.$store.state.editor.product.name}_${layer.globalKeys[globalIndex]}_crop`
            // console.log('保存全局配置', newKey)
            await setItem(newKey, e.crop)
            this.keyList.push(newKey)
            reload = true
          }
        }
      }
      this.$store.commit('updateEditor', e)
      if (e.valueProp === 'size') {
        this.size = e.value
        return
      }
      let target = null
      this.$store.state.editor.components.forEach(async c => {
        if (c.props.group) {
          c.props.group.forEach(async (g) => {
            if (g.props.id === e.id) {
              target = g
            }
          })
        } else if (c.props.id === e.id) {
          target = c
        }
      })
      // 如果修改src，且是全局配置, 且是scene场景，重载场景
      if ((this.$store.state.editor.inprint.type === 'top' || this.$store.state.editor.inprint.reload) && reload) {
        await this.changeInprint(this.$store.state.editor.inprint)
        return
      }
      if (e.valueProp === 'processer') {
        if (e.value) {
          this.$store.commit('setCurrentLayerById', e.id)
          this.showProcesser()
        }
      } else if (e.valueProp === 'visible') {
        this.setVisible(target, e)
      } else if (e.valueProp === 'color') {
        this.setColor(target, e)
      } else if (e.valueProp === 'src') {
        await this.setImage(target, e)
      } else if (e.valueProp === 'blendMode') {
        this.$store.commit('setBlendMode', e)
      }
    },
    async captureScenes () {
      if (!this.$refs.canvas) return
      // this.$store.state.ui.loading = true
      // this.$refs.canvas.style.opacity = 0
      const currentInprint = JSON.parse(JSON.stringify(this.$store.state.editor.inprint))
      // 当前拍照
      await this.captureScene(currentInprint.type)
      for (let i = 0; i < this.$store.state.editor.inprints.length; i++) {
        const inprint = this.$store.state.editor.inprints[i]
        if (currentInprint.type === inprint.type) continue
        await this.changeInprint(inprint, false)
        await this.captureScene(inprint.type)
      }
      await this.changeInprint(currentInprint, false)
      // this.$store.state.ui.loading = false
      // this.$refs.canvas.style.opacity = 1
    },
    async captureScene (type) {
      if (!this.pixiApp) return
      if (!this.pixiContainer) return
      this.pixiContainer._watermark.visible = true
      this.pixiApp.render()
      const output = this.pixiApp.view.toDataURL('image/png')
      this.pixiContainer._watermark.visible = false
      await setItem(`${this.$store.state.editor.product.name}_${type}_capture`, output)
    },
    getSceneCapture (inprint) {
      if (!this.pixiApp) return
      if (!this.pixiContainer) return
      this.pixiApp.render()
      const output = this.pixiApp.view.toDataURL('image/png')
      return output
    },
    async uploadJson (name, data) {
      const token = await getUploadToken()
      const fd = new FormData()
      fd.append('key', name + '.json')
      fd.append('token', token)
      fd.append('file', JSON.stringify(data))
      await upload2qn(fd)
    },
    async uploadImage (name) {
      const base64 = await getItem(name)
      if (base64) {
        const blob = base64ToBlob(base64, 'image/png')
        const token = await getUploadToken()
        const fd = new FormData()
        fd.append('key', name)
        fd.append('token', token)
        fd.append('file', blob)
        await upload2qn(fd)
      }
    },
    async uploadImages (crops) {
      for (let i = 0; i < crops.length; i++) {
        if (crops[i].inprint === 'scene') continue
        for (let j = 0; j < crops[i].layers.length; j++) {
          for (let k = 0; k < crops[i].layers[j].items.length; k++) {
            const item = crops[i].layers[j].items[k]
            if (item.type === 'image') {
              await this.uploadImage(item.name)
            }
          }
        }
      }
    },
    getRadioColor () {
      const color = {
        name: '',
        hex: ''
      }
      this.$store.state.editor.components.forEach((component) => {
        if (component.name === 'select-item') {
          component.props.group.forEach((item) => {
            if (item.props.visible) {
              color.name = item.props.label
              color.hex = item.props.color
              console.log('color', color.hex, item)
            }
          })
        }
      })
      return color
    },
    async getImageList (crops) {
      // 遍历logo
      const dic = {}
      for (let i = 0; i < crops.length; i++) {
        const inprint = crops[i]
        for (let k = 0; k < inprint.layers.length; k++) {
          const layer = inprint.layers[k]
          for (let j = 0; j < layer.items.length; j++) {
            const item = layer.items[j]
            if (item.type === 'image') {
              if (!dic[item.name]) {
                const base64 = await getItem(item.name)
                if (base64) {
                  dic[item.name] = {
                    name: item.name,
                    image: base64,
                    inprints: {}
                  }
                  dic[item.name].inprints[inprint.inprint] = ''
                }
              } else {
                dic[item.name].inprints[inprint.inprint] = ''
              }
            }
          }
        }
      }
      const ret = []
      for (var item in dic) {
        ret.push(dic[item])
      }
      return ret
    },
    async print (pantone = false, crops = null) {
      this.$store.state.ui.loading = true
      this.disabledPrint = true
      // 保存当前设计
      if (this.$store.state.editor.inprints) {
        await this.$store.dispatch('saveInprint', `${this.$store.state.editor.product.name}_${this.$store.state.editor.inprint.type}`)
      }
      if (!crops) {
        this.crops = await this.getProductCrops()
      }
      const color = this.getRadioColor()
      await this.captureScenes()
      // 上传json
      const name = moment().format('YYYYMMDDHHmmss')
      await this.uploadJson(name, {
        name: this.$store.state.editor.product.name,
        inprints: this.crops,
        color,
        created: moment().format('DD.MM.YYYY')
      })
      await this.uploadImages(this.crops)
      // 上传场景效果图和缩略图
      const tasks = []
      const loopInprint = async () => {
        for (let i = 0; i < this.$store.state.editor.inprints.length; i++) {
          const inprint = this.$store.state.editor.inprints[i]
          let base64 = ''
          const data = await this.getInprint(inprint)
          const loopLayers = async () => {
            const capture = await getItem(`${this.$store.state.editor.product.name}_${inprint.type}_capture`)
            if (capture) {
              tasks.push({
                key: inprint.type + '_capture',
                base64: capture
              })
            }
            for (let j = 0; j < data.layers.length; j++) {
              const layer = data.layers[j]
              layer.globalKeys = []
              layer.globalProps = []
              if (layer.global) {
                const globals = layer.global.split(',')
                globals.forEach((global) => {
                  const arr = global.split('.')
                  layer.globalKeys.push(arr[0])
                  layer.globalProps.push(arr[1])
                })
              }
              const global = {}
              for (let i = 0; i < layer.globalProps.length; i++) {
                const prop = layer.globalProps[i]
                const newKey = `${this.$store.state.editor.product.name}_${layer.globalKeys[i]}_${prop}`
                const globalValue = await getItem(newKey)
                // console.log('获取全局配置', layer.name, newKey)
                if (globalValue != null) {
                  global[prop] = globalValue
                  if (!layer.props) {
                    layer.props = {
                      visible: true
                    }
                  }
                  layer.props[prop] = globalValue
                }
              }
              if (layer.props && layer.props.crop) {
                base64 = layer.props.crop
              } else if (layer.smartobject) {
                let ratio = 1
                const max = Math.max(layer.smartobject.size.width, layer.smartobject.size.height)
                if (max > 2000) {
                  ratio = max / 2000
                }
                const url = `https://uc.shareuc.com/${this.$store.state.editor.defaultImg}?imageMogr2/gravity/Center/crop/${layer.smartobject.size.width / ratio}x${layer.smartobject.size.height / ratio}`
                const { data } = await axios({
                  method: 'get',
                  responseType: 'blob',
                  url
                })
                base64 = await blobToBase64(data)
                // console.log('blob', inprint.type)
              }
            }
          }
          await loopLayers()
          if (base64) {
            tasks.push({
              key: inprint.type,
              base64
            })
          }
        }
      }
      await loopInprint()
      const loopTasks = async () => {
        for (let i = 0; i < tasks.length; i++) {
          const task = tasks[i]
          const key = `${name}${task.key}.png`
          const blob = base64ToBlob(task.base64, 'image/png')
          const token = await getUploadToken()
          const fd = new FormData()
          fd.append('key', key)
          fd.append('token', token)
          fd.append('file', blob)
          await upload2qn(fd)
          // console.log('上传图片', key)
        }
      }
      await loopTasks()
      this.disabledPrint = false
      this.$store.state.ui.loading = false
      window.open(`https://shareuc.com/share3d/fareDetailsRender.html?name=${name}&id=${this.$store.state.editor.product.id}`, '_blank')
    },
    async handleDrop (e) {
      // console.log('canvas drop')
      e.preventDefault()
      if (e.dataTransfer) {
        if (!this.$store.state.editor.currentLayer) {
          console.error('没有选中层')
          return
        }
        const file = e.dataTransfer.files[0]
        if (file) {
          this.$store.state.ui.loading = true
          const convert = new ConvertFile(file, async (e) => {
            if (e.msg === 'success') {
              this.$store.state.ui.loading = false
              this.showProcesser(e.data)
            } else {
              console.log('转换失败', e.msg, e.data)
              alert('Failed to import image')
              this.$store.state.ui.loading = false
            }
          })
          convert.start()
        }
      } else {
        console.error('e.dataTransfer not exist')
      }
    },
    events () {
      return {
        dragover: (e) => {
          e.preventDefault()
        },
        dragleave: (e) => {
          e.preventDefault()
        },
        drop: this.handleDrop
      }
    }
  },
  mounted () {
    this.updateAffix = () => {
      this.$refs.affix && this.$refs.affix.updatePosition()
    }
    window.addEventListener('scroll', this.updateAffix)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.updateAffix)
  }
}
</script>

<style lang="scss" scoped>
.design-title {
  font-weight: bold;
  font-size: 20px;
  margin-left: 5vw;
  line-height: 60px;
  padding: 0;
  margin-top: 50px;
  margin-bottom: 20px;
}
.design-title-phone {
  font-weight: bold;
  font-size: 20px;
  margin-left: 10px;
  line-height: 40px;
  padding: 0;
  text-align: center;
  height: 40px;
  margin-top: 25px;
  max-width: 100vw;
}
.design-content {
  margin-left: 5vw;
  margin-right: 5vw;
  margin-bottom: 0;
}
.design-area {
  width: 60%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.design-content-phone {
  margin: 10px;
}

.el-main {
  padding: 0;
  text-align: center;
}
.box-card {
  max-width: 440px;
  padding: 20px;
  box-sizing: border-box;
}
.box-card-phone {
  margin-top: 10px;
  text-align: center;
}
.back-button {
  position: absolute;
  margin-left: 5vw;
  margin-top: 15px;
  color: gray;
}
.back-button-phone {
  position: absolute;
  margin-left: 10px;
  color: gray;
}
.back-button:hover {
  color: #0677FF;
}
.is-dragover {
  border: 2px solid red !important;
}
.upload-area {
  width: 200px;
  height: 200px;
  border: 2px solid black;
}
.affix-container {
  min-height: calc(100vh - 220px);
}
.far {
  left: 9999px;
}
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 10px;
}
</style>
